 <template>

   <!--系统维护中-->
   <div class="P400">
     <div class="not-found">
       <img src="../assets/system_01.png" alt="">

       <p class="txt1">客服热线：<a class="focus-btn" href="tel:18728497523">18728497523</a></p>
       <p class="txt2">若您遇到问题，请联系我们，我们将为您及时解决</p>
     </div>
   </div>


</template>

 <script>

   import { mapState, mapMutations } from 'vuex'

   import wxConfirm from '@/wechat-messagebox/Confirm'
   import D from '@/wc-messagebox'
   import Vue from 'vue'
   Vue.use(D)

   export default {
     data(){
       return{
         res: {}
       }
     },
     computed: {

     },
     created() {
       this.$loading.hide();
     },
     methods: {

     },
     components: {

     },

   }

 </script>


<style scoped>
  .P400{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 9999; width: 100%; height: 100%; background-color: #fff; }
  .not-found{ padding-top: 20%; margin: 0 auto; text-align: center;  }
  .not-found img{ width: 46%; height: auto;  }
  .not-found .txt1{ font-size: .34rem; color: #666; line-height: .4rem;  }
  .not-found .txt1 a{color: #f30;}
  .not-found .txt2{ margin-top: .15rem; font-size: .26rem; color: #666;}
</style>



// WEBPACK FOOTER //
// src/components/P400.vue